/**
 * Value equality for the dateRange input. The parent re-binds a fresh `[]` / `[start, end]` array
 * literal on every change-detection pass; comparing by content (not reference) lets the derived
 * signal below suppress those no-op changes so the form sync doesn't wipe in-progress input.
 */
export function dateRangeEqual(a: Date[], b: Date[]): boolean {
    return a.length === b.length && a.every((date, index) => date.getTime() === b[index].getTime());
}
